import React, { Component, Fragment  } from 'react';
import intl from 'react-intl-universal';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Moment from 'react-moment';
import moment from 'moment';
import DatePicker from '@mui/lab/DatePicker';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import ShowTextDetail from '../ShowTextDetail';

import { CSVLink } from "react-csv";

import Loading  from '../Loading';
import LoadingDL  from '../LoadingDL';



// import { NavLink } from 'react-router-dom';

  


  class ActivitiesListResults extends Component {

    constructor(props) {
      super(props);
  
      this.state = {
        auditlogs: [],
        limit: 10,
        page: 0,
        count: 0,
        sortmode: "desc",
        sortmodelevel: "asc",
        sortmodeaction: "asc",
        sortmodedate: "desc",
        sort: "timeStamp",
        datefrom: null,
        dateto: null,
        searchstring: "",
        loaddata: true,
        loaderror: false,
        loadcsv: true,
        csvdata: [],
        exportcsv: false

      }

      this.handleLimitChange = this.handleLimitChange.bind(this);
      this.handlePageChange = this.handlePageChange.bind(this);
      this.closeexportcsvdata = this.closeexportcsvdata.bind(this);
      this.getexportcsvdata = this.getexportcsvdata.bind(this)
    }

    componentDidMount() {

      let datefrom =  new Date()
      datefrom = moment(datefrom)
      datefrom.set({hour:0,minute:0,second:0,millisecond:0})
      datefrom.subtract(7, 'd').format()

      let dateto =  new Date()
      dateto = moment(dateto)
      dateto.set({hour:23,minute:59,second:59,millisecond:0}).format()

      this.setState ({
        datefrom: datefrom._d,
        dateto: dateto._d
      })

      this.getrecords(this.props.apitoken, 0 , this.state.limit , this.state.sortmode, this.state.sort, this.state.searchstring, datefrom._d, dateto._d);
    }
    
 
     handleLimitChange = (event) => {
      this.setState ({
        limit: event.target.value,
        loaddata: true
      })


      this.getrecords(this.props.apitoken, this.state.page , event.target.value, this.state.sortmode, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto);  
    };
  
    handlePageChange = (event, newPage) => {  
      this.setState ({
        page: newPage,
        loaddata: true    
    })
    this.getrecords(this.props.apitoken, newPage + 1, this.state.limit, this.state.sortmode, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto);  
    }; 
    
     // Sort Funktionen
     sortdescmessage = (event) => {
      this.setState ({
        sortmode: "desc",
        sort: "operation",
        loaddata: true    
    })
    this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmode, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
    }

    sortascmessage = (event) => {
      this.setState ({
        sortmode: "asc",
        sort: "operation",
        loaddata: true    
    })
    this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmode, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
    }
    
    sortdesclevel = (event) => {
      this.setState ({
        sortmodelevel: "desc",
        sort: "level",
        loaddata: true    
    })
    this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
    }

    sortasclevel = (event) => {
      this.setState ({
        sortmodelevel: "asc",
        sort: "level",
        loaddata: true    
    })
    this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
    }

    sortdescaction = (event) => {
      this.setState ({
        sortmodeaction: "desc",
        sort: "action",
        loaddata: true    
    })
    this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodeaction, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
    }

    sortascaction = (event) => {
      this.setState ({
        sortmodeaction: "asc",
        sort: "action",
        loaddata: true    
    })
    this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodeaction, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
    }

    sortdescdate = (event) => {
      this.setState ({
        sortmodedate: "desc",
        sort: "timestamp",
        loaddata: true    
    })
    this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodedate, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
    }

    sortascdate = (event) => {
      this.setState ({
        sortmodedate: "asc",
        sort: "timestamp",
        loaddata: true    
    })
    this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodedate, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
    }

    fullsearch = (event) => {
      event.preventDefault()
      this.setState ({
        searchstring: event.target.searchstring.value,
        page: 0,
        loaddata: true
    })
    this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, event.target.searchstring.value, this.state.datefrom, this.state.dateto); 
    }


    handledatefrom(datefrom){
    console.log(datefrom)
     if (datefrom !== null){
      datefrom.set({hour:0,minute:0,second:0,millisecond:0})
      this.setState({
        datefrom: datefrom._d
      }); 
    } else {
      this.setState({
        datefrom: null
      }); 
    }
    }
  
    handledateto(dateto){
      if (dateto !== null){
      dateto.set({hour:23,minute:59,second:59,millisecond:0})
      this.setState({
        dateto: dateto._d
      });
      } else {
      this.setState({
        dateto: null
      }); 
    }
      
  }

handlefilterdate= (event) =>{
    event.preventDefault()
    this.setState({
      loaddata: true
    });
    this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto);
}

getexportcsvdata = (event) =>{
  this.setState({
    exportcsv: true
  });
  this.getrecordscsv(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto);
}

closeexportcsvdata = (event) =>{
  this.setState({
    exportcsv: false,
    csvdata: [],
    loadcsv: true,
  });
}
    
    



    getrecords (token,page,limit,sortmode,sort,searchstring,datefrom,dateto)  {
      let apiurl = window.apiurl

      if (searchstring === undefined){
        searchstring = "";
      }
      
      if (datefrom === null || datefrom === undefined){
        datefrom = "";
      } else {
        datefrom = encodeURIComponent(datefrom.toISOString())
        console.log(datefrom)
      }
      

      if (dateto === null || dateto === undefined){
        dateto = "";
      } else {
        dateto = encodeURIComponent(dateto.toISOString())
        console.log(dateto)
      }

      fetch("https://"+apiurl+"/api/AuditLog?pageNumber="+page+"&PageSize="+limit+"&Sort="+sort+"&SortMode="+sortmode+"&From="+datefrom+"&To="+dateto+"&query="+searchstring+"", {  
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
          },
        })
          .then(res => res.json())
          .then(json => {
            console.log("---------------")
            console.log(json)
            console.log("---------------")
            this.setState ({
                auditlogs: json.data,
                count: json.totalRecords,
                loaddata: false
            })  
            
          })
          .catch(error => {
              console.log(error.status);
              this.setState ({
                loaddata: false,
                loaderror: true
            })  
          });         
        }

        getrecordscsv (token,page,limit,sortmode,sort,searchstring,datefrom,dateto)  {
          let apiurl = window.apiurl
          
    
          if (searchstring === undefined){
            searchstring = "";
          }
         
          if (datefrom === null || datefrom === undefined){
            datefrom = "";
          } else {
            datefrom = encodeURIComponent(datefrom.toISOString())
          }
          
    
          if (dateto === null || dateto === undefined){
            dateto = "";
          } else {
            dateto = encodeURIComponent(dateto.toISOString())
          }
    
    
    
    
    
          fetch("https://"+apiurl+"/api/AuditLog?pageNumber="+page+"&PageSize="+limit+"&Sort="+sort+"&SortMode="+sortmode+"&From="+datefrom+"&To="+dateto+"&export=csv&query="+searchstring +"", {
              method: 'GET',
              headers: {
                'Accept': 'text/csv',
                'Content-Type': 'text/csv',
                'Authorization': 'Bearer ' + token,
              },
            })
              .then(res => res.text())
              .then(text => {
                this.setState ({
                  csvdata: text,
                  loadcsv: false
              })
                
               
              })
              .catch(error => {
                console.log(error.status);
                this.setState ({
                  loaddata: false,
                  loaderror: true,
                  
              })  
            });               
            }


        handleChange(e) {
          this.setState({
            [e.target.name]: e.target.value
          })
        }





render () {
     
  // console.log(this.state) 
  let outdatefrom = moment(this.state.datefrom).format("DD-MM-YYYY")
  let outdateto = moment(this.state.dateto).format("DD-MM-YYYY")
  let filenname ="AuditLog_"+outdatefrom+"-"+outdateto+".csv"

  if (this.state.loaddata) {
      return (
        <Loading />
      )
    }

  if (this.state.loaderror) {
      return (
        <Alert severity="error"><strong>{intl.get('LIST_DATA_ERROR')}</strong><br />{intl.get('LIST_DATA_ERROR_DESC')}</Alert>
      )
    }

  return (
    <Fragment>
      
  <Box component="form" onSubmit={this.fullsearch} sx={{ mt: 4, mb: 4, p: 2, border: '1px dashed grey', borderRadius: 2, bgcolor: '#edf3f7' }}>
    <Grid container spacing={2}>
      <Grid item xs={11} sm={9} md={9} lg={4} xl={5}>
      <FormControl variant="standard" fullWidth sx={{ m: 1 }}>
        <InputLabel htmlFor="input-with-icon-adornment">
        {intl.get('LIST_SEARCH_LABEL')}
        </InputLabel>
        <Input
          id="input-with-icon-adornment"
          name="searchstring"
          value={this.state.searchstring} 
          onChange={(e) => this.handleChange(e)}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
      </FormControl>
      </Grid>
      <Grid item  xs={12} sm={2} md={1} lg={1} xl={1}>
      <Button
            type="submit"
            variant="contained"
            sx={{ mt: 1, mb: 1 }}
          >
            {intl.get('LIST_SEARCH_BUTTON')}
          </Button>
          </Grid> 
          <Grid item xs={2}>
        <DatePicker
        label={intl.get('LIST_DATE_FROM')}
        inputFormat='DD.MM.YYYY'
        onChange={val => {
          this.handledatefrom(val);
        }} 
        value={this.state.datefrom}
        renderInput={(params) => <TextField {...params} />}
      />
      </Grid>
      <Grid item xs={12} sm={5} md={5} lg={3} xl={2}>
      <DatePicker
        label={intl.get('LIST_DATE_TO')}
        inputFormat='DD.MM.YYYY'
        onChange={val => {
          this.handledateto(val);
        }} 
        value={this.state.dateto}
        renderInput={(params) => <TextField {...params} />}
      />
      </Grid>
      <Grid item xs={6} sm={5} md={1} lg={1} xl={1}>
      <Button onClick={this.handlefilterdate}

            variant="contained"
            sx={{ mt: 1, mb: 1 }}
          >
            {intl.get('LIST_DATE_FILTER')}
          </Button>
          </Grid>
        <Grid item xs={6} sm={5} md={6} lg={6} xl={1}>
        {this.state.exportcsv &&    
        <Button onClick={this.closeexportcsvdata}
            variant="contained"
            sx={{ mt: 1, mb: 1 }}
          >
            <span>{intl.get('CSV_LIST_BUTTON')}</span>
        </Button>
        }

        {!this.state.exportcsv &&    
        <Button onClick={this.getexportcsvdata}
            variant="contained"
            sx={{ mt: 1, mb: 1 }}
          >
            <span>{intl.get('CSV_DLS_BUTTON')}</span>
        </Button>
        }
        
        
        </Grid>
      </Grid>
      </Box>

      {!this.state.exportcsv &&
     <Fragment>

      <Box  sx={{ mt: 4, mb: 4, p: 2, border: '1px dashed grey', borderRadius: 2, bgcolor: 'rgb(248, 248, 248)' }}>
          <Table>
            <TableHead>
              <TableRow>
              <TableCell style={{width:'10%'}}> 
              {intl.get('LIST_AUDLOG_TYPE')} {this.state.sortmode === "asc" &&
                    <ArrowDropDownIcon onClick={this.sortdescmessage} />
                  } 
                  {this.state.sortmode === "desc" &&
                    <ArrowDropUpIcon onClick={this.sortascmessage} />
                  }
                </TableCell>
                <TableCell style={{width:'70%'}}>
                {intl.get('LIST_AUDLOG_EINTRAG')} {this.state.sortmodeaction === "asc" &&
                    <ArrowDropDownIcon onClick={this.sortdescaction} />
                  } 
                  {this.state.sortmodeaction === "desc" &&
                    <ArrowDropUpIcon onClick={this.sortascaction} />
                  } 
                </TableCell>
                <TableCell style={{width:'10%'}}>
                {intl.get('LIST_AUDLOG_LEVEL')}  {this.state.sortmodelevel === "asc" &&
                    <ArrowDropDownIcon onClick={this.sortdesclevel} />
                  } 
                  {this.state.sortmodelevel === "desc" &&
                    <ArrowDropUpIcon onClick={this.sortasclevel} />
                  } 
                </TableCell>
                <TableCell style={{width:'10%'}}>
                {intl.get('LIST_AUDLOG_DATE')}
                {this.state.sortmodedate === "asc" &&
                    <ArrowDropDownIcon onClick={this.sortdescdate} />
                  } 
                  {this.state.sortmodedate === "desc" &&
                    <ArrowDropUpIcon onClick={this.sortascdate} />
                  } 
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              
              {this.state.auditlogs.map((auditlog) => (
                <TableRow
                  hover
                  key={auditlog.id}
                > <TableCell>
                    <Typography
                        color="textPrimary"
                        variant="body1"
                      >
                        {auditlog.operation}
                      </Typography>
                      </TableCell>
                  <TableCell>
                  
                      <Typography>
                        {auditlog.user.firstName} {auditlog.user.lastName} | <strong>{auditlog.message}</strong>
                      </Typography>
                      <ShowTextDetail textdata={auditlog.messageDetails} />
                    
                  </TableCell>
                  <TableCell>
                    
                  {auditlog.level} 
                    
                  </TableCell>
                  <TableCell>
                  <Moment format="DD.MM.YYYY, HH:mm:ss">{auditlog.timeStamp}</Moment>
                  </TableCell>
                 
                </TableRow>
              ))}
            </TableBody>
          </Table>
      </Box>
      <Box sx={{ mt: 4, mb: 4, p: 2, border: '1px dashed grey', borderRadius: 2, bgcolor: '#edf3f7' }}>
      <TablePagination
        component="div"
        count={this.state.count}
        onPageChange={this.handlePageChange}
        onRowsPerPageChange={this.handleLimitChange}
        page={this.state.page}
        rowsPerPage={this.state.limit}
        rowsPerPageOptions={[5, 10, 25]}
      />
      </Box>
      </Fragment>
      }

{this.state.exportcsv &&
    <Fragment>
      <Box  sx={{ mt: 4, mb: 4, p: 2, border: '1px dashed grey', borderRadius: 2, bgcolor: 'rgb(248, 248, 248)' }}>
      <Grid container spacing={2} >
          <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
      <Alert severity="info">
        <AlertTitle>{intl.get('CSV_HEAD_INFO')}</AlertTitle>
        {intl.get('CSV_CONT_INFO')}  
        </Alert>
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={5} xl={5} align="center">
        {this.state.csvdata.length === 0 && this.state.loadcsv &&
             <LoadingDL />
        }

        {this.state.csvdata.length !== 0 && !this.state.loadcsv &&
        <CSVLink
          data={this.state.csvdata}
          filename={filenname}
          className="dashbuttondl"
          target="_blank"
        >
         {intl.get('CSV_DL_BUTTON')}
      </CSVLink>
      }
        </Grid>
       </Grid> 
    </Box>
    </Fragment>

    }


     </Fragment>
  );
};
  }



export default ActivitiesListResults;
